import { Component, inject } from '@angular/core';
import { ModalRef } from '@df/ui/modal/modal-ref';

@Component({
    selector: 'modal-layout-middle2',
    templateUrl: 'modal-layout-middle2.html',
    styleUrls: ['./modal-layout-middle2.scss'],
    standalone: true
})
export class ModalLayoutMiddle2Component {
    private modalRef = inject(ModalRef);

    protected close() {
        this.modalRef.close();
    }
}
